function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  d: "M9.846,965.393A1.848,1.848,0,0,0,8,967.24v10.549a1.848,1.848,0,0,0,1.846,1.846h2.761l-.511,4.978a.278.278,0,0,0,.453.214l5.209-5.192h2.11v1.071a1.31,1.31,0,0,0,1.31,1.3h4.08l2.868,2.819a.278.278,0,0,0,.445-.231l-.453-2.588h.725a1.31,1.31,0,0,0,1.31-1.3v-5.044a1.31,1.31,0,0,0-1.31-1.3H26.989V967.24a1.848,1.848,0,0,0-1.846-1.846Zm0,.527h15.3a1.31,1.31,0,0,1,1.319,1.319v10.549a1.31,1.31,0,0,1-1.319,1.319H17.651a.262.262,0,0,0-.19.074L12.7,983.937l.47-4.541a.275.275,0,0,0-.264-.288H9.846a1.31,1.31,0,0,1-1.319-1.319V967.24A1.31,1.31,0,0,1,9.846,965.921Zm1.846,2.9a.264.264,0,1,0,0,.527H23.3a.264.264,0,1,0,0-.527Zm0,3.429a.264.264,0,1,0,0,.527H23.3a.264.264,0,1,0,0-.527Zm15.3,2.637h1.854a.773.773,0,0,1,.783.775v5.044a.773.773,0,0,1-.783.775H27.8a.275.275,0,0,0-.264.3l.371,2.093-2.365-2.324a.267.267,0,0,0-.181-.074H21.179a.773.773,0,0,1-.783-.775v-1.071h4.747a1.848,1.848,0,0,0,1.846-1.846Zm-15.3.791a.264.264,0,1,0,0,.527H23.3a.264.264,0,1,0,0-.527Z",
  transform: "translate(-7.75 -965.143)",
  fill: "#566fff",
  stroke: "#566fff",
  strokeWidth: 0.5
});

var SvgJoratoComment = function SvgJoratoComment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.654,
    height: 20.009,
    viewBox: "0 0 22.654 20.009",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJoratoComment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jorato-comment.2a8da60f.svg";
export { ForwardRef as ReactComponent };